export default defineNuxtPlugin((nuxtApp) => {
  const { RIGHTMESSAGE_PROJECT_ID } = nuxtApp.$config.public
  if (!RIGHTMESSAGE_PROJECT_ID) return

  const { loadScript } = useHelpers()

  nuxtApp.hook('app:mounted', () => {
    console.info('Loading RightMessage...')

    // Initialize RightMessage array
    window.RM = window.RM || []

    // Load RightMessage script
    loadScript(`https://t.rightmessage.com/${RIGHTMESSAGE_PROJECT_ID}.js`, true, false, () => {
      console.info('RightMessage loaded successfully')
    })
  })
})
